import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { isSingleOfferProductWithOffer } from '@uno/common-cms';
import BackButton from 'components/common/BackButton';
import { ImagePreview } from 'components/common/ImagePreview';
import Loader from 'components/common/Loader';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { SearchProduct } from 'components/content/SearchProduct';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { getProduct } from 'services/networking/affiliation';
import { Description } from '../AffiliationBlockTypeSlideshow.style';
import { ButtonContainer, ImagePreviewContainer, InputContainer, InputTitle, LoaderContainer, NoOffer } from './AddSlide.style';

var AddSlide = function AddSlide(_ref) {
  var products = _ref.products,
      selectedIndex = _ref.selectedIndex,
      onConfirm = _ref.onConfirm,
      onBack = _ref.onBack;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id,
      lang = _useSiteConfig.lang;

  var intl = useIntl();

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState(),
      product = _useState[0],
      setProduct = _useState[1];

  var _useState2 = useState(),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var _useState3 = useState(),
      title = _useState3[0],
      setTitle = _useState3[1];

  var _useState4 = useState(false),
      isTitleCustomized = _useState4[0],
      setIsTitleCustomized = _useState4[1];

  var _useState5 = useState(),
      image = _useState5[0],
      setImage = _useState5[1];

  var _useState6 = useState(false),
      productLoading = _useState6[0],
      setProductLoading = _useState6[1];

  var listExists = products !== undefined && products.length > 0;
  useEffect(function () {
    var selectedProduct = selectedIndex === undefined || (products === null || products === void 0 ? void 0 : products[selectedIndex]) === undefined ? undefined : products[selectedIndex];
    setProduct(selectedProduct);
    setTitle(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.name);
    setIsTitleCustomized((selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.name) !== undefined);
    setImage(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.image);
  }, [products, selectedIndex]);
  useEffect(function () {
    if (searchText === undefined && product !== undefined) {
      setSearchText(product.name);
    }
  }, [product, searchText]);

  var onProductClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newProduct, search) {
      var selectedProduct;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setProductLoading(true);
              setSearchText(search);
              selectedProduct = {
                apiId: newProduct.apiId,
                productId: newProduct.productId,
                name: '',
                offer: null
              };
              _context2.next = 5;
              return snackAsyncError({
                messageId: 'affiliation.error.get-product',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$getProduct, name, offer;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getProduct(lang, newProduct.apiId, newProduct.productId, site);

                          case 2:
                            _yield$getProduct = _context.sent;
                            name = _yield$getProduct.name;
                            offer = _yield$getProduct.offer;
                            setProduct(_objectSpread(_objectSpread({}, selectedProduct), {}, {
                              name: name,
                              offer: offer
                            }));

                            if (!isTitleCustomized) {
                              setTitle(name);
                            }

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 5:
              setProductLoading(false);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onProductClick(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleConfirm = function handleConfirm() {
    if (product !== undefined) {
      onConfirm(_objectSpread(_objectSpread({}, product), {}, {
        name: title !== null && title !== void 0 ? title : product.name,
        image: image
      }), selectedIndex);
    }
  };

  var handleBack = function handleBack() {
    if (listExists && product === undefined || // search step & slideList exists
    selectedIndex !== undefined // editing slide
    ) {
      onBack(); // back to slide list

      return;
    } // Addind product: go back to search:


    setProduct(undefined);
  };

  var searchProduct = function searchProduct() {
    return __jsx(React.Fragment, null, __jsx(SearchProduct, {
      initialSearchText: searchText,
      onProductClick: onProductClick
    }), listExists && __jsx(ButtonContainer, null, __jsx(BackButton, {
      onClick: handleBack
    })));
  };

  if (productLoading) {
    return __jsx(LoaderContainer, null, __jsx(Loader, null));
  }

  if (product === undefined) {
    return searchProduct();
  }

  return __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.description",
    tagName: Description
  }), __jsx(InputContainer, null, __jsx(TextField, {
    id: "affiliation-slideshow-modal-slide-title",
    value: title,
    fullWidth: true,
    type: "text",
    onChange: function onChange(event) {
      setTitle(event.target.value);
      setIsTitleCustomized(true);
    },
    label: intl.formatMessage({
      id: 'affiliation-slideshow-modal.slide.title'
    }),
    variant: "outlined"
  })), isSingleOfferProductWithOffer(product) ? __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.slide.picture",
    tagName: InputTitle
  }), __jsx(ImagePreviewContainer, null, __jsx(ImagePreview, {
    imageData: image,
    onConfirm: function onConfirm(imageData) {
      setImage(imageData);
    },
    onRemove: function onRemove() {
      return setImage(undefined);
    },
    compulsory: true
  }))) : __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.slide.no-offer",
    tagName: NoOffer
  }), __jsx(ButtonContainer, null, __jsx(BackButton, {
    onClick: handleBack
  }), __jsx(GradientButton, {
    disabled: !isSingleOfferProductWithOffer(product) || (title !== null && title !== void 0 ? title : '') === '' || image === undefined,
    onClick: handleConfirm,
    "aria-label": intl.formatMessage({
      id: 'affiliation-slideshow-modal.slide.next'
    })
  }, __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.slide.next"
  }))));
};

export default AddSlide;